import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Select, Spin } from 'antd';
import { formItemLayout, tailFormItemLayout, backButton, handleBackendFormErrors, unexpectedError } from '../../common_functions';

const MountCondition = props => {
  const { section, id } = useParams();
  const [mountCondition, setMountCondition] = useState({});
  const [mountType, setMountType] = useState([]);
  const [loading, setLoading] = useState(false);
  const formRef = useRef('');

  useEffect(() => {
    const fetchMountTypes = async () => {
      try {
        setLoading(true);
        const mount_type = await props.getItems('mount_type', {
          fields: ['id', 'name'],
          sort: '-id',
          limit: '-1',
        });
        setMountType(mount_type.data);
        if (id !== 'new') {
          const { data } = await props.getItem('mount_conditions', id);
          setMountCondition(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchMountTypes();
  }, [section, id]);

  let onFinish = async values => {
    try {
      let newState = { ...mountCondition, ...values };
      let response = await props.saveItem('mount_conditions', newState);
      if (response) {
        notification['success']({
          message: 'Mount condition type saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/mount-condition-type`);
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    }
  };

  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/mount-condition-type" }, { title: "Mount Conditions Rating", href: "/settings/mount-condition-type" }, { title: id !== 'new' ? `Edit Mount Condition Type` : 'Create Mount Condition Type' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit Mount Condition Type: ${id}` : 'Create Mount Condition Type'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              <Row gutter={24}>
                {id !== 'new' && (
                  <>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="id" label="ID (System Generated)">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </>
                )}
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="mcondition"
                    label="Mount Condition Type"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Mount condition type is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter mount condition type" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="mtype"
                    label="Mount Type"
                    rules={[
                      {
                        required: true,
                        message: 'Mount type is required!',
                      },
                    ]}
                  >
                    <Select placeholder="Select mount type">
                      {!!mountType.length &&
                        mountType.map(m_type => {
                          return <Select.Option key={m_type.id} value={m_type.id}>{m_type.name}</Select.Option>;
                        })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item name="description" label="Description">
                    <Input.TextArea placeholder="Description" autosize={{ minRows: 3 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/mount-condition-type')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(
                  props.roleType,
                  props.tabs_permissions.settings_mount_condition_type,
                  !!mountCondition ? mountCondition.id : ''
                )}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};
export default MountCondition;
